export default __webpack_public_path__ + "static/theme-gen-logo-full-cbbf502faf23f0629cc24cb491486614.svg";